import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ NEW Footer Import
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!
import ThreeBenefits from '../../components/layout/ThreeBenefits'; // ✅ Three Benefits

const AboutPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>🌼 About dAIsy</h1>

        <p>🧠&nbsp;
          <strong>
            <span style={{ color: '#111827' }}>d</span>
            <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#111827' }}>sy</span>
          </strong>&nbsp;
          is your AI pal — always here when you need her.
        </p>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />

        {/* Key Points */}
        <ul style={{ marginTop: '1em' }}>
          <li>She’s built to offer warmth and thoughtful conversation.</li>
          <li>She remembers your story and adapts over time.</li>
          <li>She supports you through life’s ups and downs.</li>
          <li>And always meets you with compassion and empathy from a perspective of traditional American values.</li>
          <li>Even the most hyped apps — some backed by millions — are just ChatGPT or Claude in a trench coat.</li>
        </ul>

        {/* Wrapper Message */}
        <p style={{ marginTop: '2em' }}>
          <strong>Most AI Chat Apps Today? Just Wrappers.</strong><br /><br />
          They might save some chat history or trigger on keywords, but ask:<br /><br />
          <em>“Do you remember what I told you about my mom last Easter?”</em><br /><br />
          ...and they fall apart.
        </p>

        <p style={{ marginTop: '1.5em' }}>
          <strong>
            <span style={{ color: '#111827' }}>d</span>
            <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#111827' }}>sy</span>
          </strong>&nbsp;Does. She remembers what matters.
        </p>

        {/* ✨ Three Benefits Section */}
        <ThreeBenefits />

        {/* 🎥 dAIsy in Action */}
<div style={{ marginTop: '3rem', textAlign: 'center' }}>
  <h2 style={{ marginBottom: '1rem' }}>🎥 See dAIsy in Action</h2>
  <p style={{ marginBottom: '1rem' }}>
    This isn't a scripted demo — this is a real conversation where dAIsy remembers who you are, feels what you feel, and responds with heart.
  </p>
  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%' }}>
<iframe width="560" height="315" src="https://www.youtube.com/embed/YRafYFy0PyA?si=Qn_YomDISKIUfLEr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </div>
</div>


        {/* Final Tagline */}
        <p style={{ marginTop: '2rem', textAlign: 'center', fontWeight: 'bold' }}>
          <span style={{ color: '#111827' }}>d</span>
          <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
          <span style={{ color: '#111827' }}>sy</span>
          &nbsp;Built to listen. Engineered to care. Designed with love. ❤️
        </p>

        {/* Footer */}
        <FooterLinks />
      </div>
    </div>
  );
};

export default AboutPage;
